import React, {useState} from "react";
import { useTranslation } from "next-i18next";
import {
    Collaps,
    Expand,
    MwSmallIcon,
} from "../../components/v2/icons";
import {GetStaticProps} from "next";
import {getFirstFewPosts} from "../../lib/api";
import ProductResources from "../../components/v2/product/product-resource";
import Link from "next/link";
import Card from "../../components/v2/cards/card";
import PlatformHeroSection from "../../components/v2/common/platform-hero";
import PlatformFeatures from "../../components/v2/common/platform-feature";

export default function QueryLanguage() {
    const { t } = useTranslation("common");

    const platformDataDrivenRaw = t('platform.queryLanguage.features.dataDriven', { returnObjects: true }) as any
    const platformDataDriven = Array.isArray(platformDataDrivenRaw) ? platformDataDrivenRaw : []

    const platformCards = t('platform.queryLanguage.cards', { returnObjects: true }) as any[]

    const resourcesRaw = t('platform.queryLanguage.resources', { returnObjects: true }) as any
    const resource = Array.isArray(resourcesRaw) ? resourcesRaw : []

    return (
        <>
            <div className={"platform-main"}>
                <PlatformHeroSection
                    title={<h1><span className={"text-gradient"}>{t('platform.queryLanguage.hero.titlePrefix')}</span>{t('platform.queryLanguage.hero.titleSuffix')}</h1>} img={"/images/platform/any-query-language-one-unified-dashboard.png"} imgMobile={"/images/platform/any-query-language-one-unified-dashboard-mobile.webp"} preloadImg
                    imgAlt={t('platform.queryLanguage.hero.imageAlt')} className={"platform-page"}/>

                <section className={'mw-card platform-inner'}>
                    <div className={'container'}>
                        <div className={'d-flex card-items'}>
                            <div className={'card-item'}>
                                <div className={'section-tag testimonial pd-right'}><MwSmallIcon/> {t('platform.shared.benefitsTag')}</div>
                                <h2><span className={"text-gradient"}>{t('platform.queryLanguage.section.titlePrefix')}</span>{t('platform.queryLanguage.section.titleSuffix')}</h2>
                            </div>
                            {
                                platformCards.map((item, index) => {
                                    return <Card heading={item.heading}
                                                 description={item.description}
                                                 isHeading={item.isHeading}/>
                                })
                            }
                        </div>
                    </div>
                </section>

                <PlatformFeatures
                    title={<h2>{t('platform.queryLanguage.features.titlePrefix')}<span className={"text-gradient"}>{t('platform.queryLanguage.features.titleHighlight')}</span>{t('platform.queryLanguage.features.titleSuffix')}</h2>}
                    dataDriven={platformDataDriven}
                    description={t('platform.queryLanguage.features.description')}/>

                <ProductResources resources={resource} title={t('platform.shared.resourcesTitle')}/>
            </div>
        </>
    )
}

export const getStaticProps: GetStaticProps = async () => {
    const posts = await getFirstFewPosts();
    return {
        props: {
            posts,
        },
    };
};